import React, { ReactElement } from "react";
import HeaderComponent from "../../../component/header";

export default function Header(): ReactElement {
  return <HeaderComponent />;
}
